<template>
  <v-container fluid>
    <v-row class="text-center" justify="center">
      <v-col cols="12" sm="8" md="7">
        <v-card class="elevation-12" max-width="800" min-width="400">
          <v-toolbar dark color="primary">
            <v-col>
              <v-toolbar-title>
                {{ $t('Статистика по торговым процедурам') }}
              </v-toolbar-title>
            </v-col>
          </v-toolbar>
          <v-card-text>
            <v-progress-linear :active="isLoading" color="loader" indeterminate />
            <general-error v-if="!!generalError" />
            <ValidationObserver ref="report" @keydown.native.enter="focusOnBtn('getReportBtn')">
              <validatable-date-picker
                  v-model="params.startIntervalDate"
                  rules="required"
                  :label="$t('Дата начала периода')" />
              <validatable-date-picker
                  v-model="params.endIntervalDate"
                  rules="required"
                  :label="$t('Дата окончания периода')" />
            </ValidationObserver>
          </v-card-text>
          <v-card-actions>
            <v-btn
                id="getReportBtn"
                ref="getReportBtn"
                v-test="{ btn: 'getReport' }"
                color="primary"
                :disabled="isLoading"
                @click.stop="getLotsReport">
              {{ $t('Получить отчет') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import ValidatableDatePicker from '@/components/reused/ui/ValidatableDatePicker.vue'
  import { mapActions } from 'vuex'
  import { REPORTS } from '@/constants/store.js'

  export default {
    components: {
      GeneralError,
      ValidatableDatePicker
    },
    data () {
      return {
        isLoading: false,
        params: {
          startIntervalDate: this.$moment().add(-1, 'months').format('YYYY-MM-DDTHH:mm:ss'),
          endIntervalDate: this.$moment().format('YYYY-MM-DDTHH:mm:ss')
        }
      }
    },
    methods: {
      ...mapActions(REPORTS.NAMESPACE, {
        getLotsReportAction: REPORTS.ACTIONS.GET_LOTS_REPORT
      }),
      getLotsReport: async function () {
        const result = await this.$refs.report.validate()
        if (!result) {
          return
        }
        try {
          this.isLoading = true
          await this.getLotsReportAction(this.params)
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      }
    }
  }
</script>
